module.exports = __webpack_public_path__ + "img/home_icon_ziyuan_normal.598fde57.png";